// extracted by mini-css-extract-plugin
module.exports = {"background":"Body_background__2A3Im","title":"Body_title__3aFfK","text":"Body_text__2w_hj","buttons":"Body_buttons__2I8L7"};